import {
  TFacility,
  TFixtureLabels,
  TPackageRoom,
} from "components/Fixtures/Fixtures.types";
import { Loader } from "shared";
import PackageRoom from "./PackageRoom";
import { useAPI } from "hooks";

type TPackageRoomsProps = {
  facility: TFacility;
  domain: string;
  labels: TFixtureLabels;
  renderPrice: (price: number, fractionDigitsCount?: number) => string;
};

function PackageRooms({
  facility,
  domain,
  labels,
  renderPrice,
}: TPackageRoomsProps) {
  const { data, isLoading } = useAPI<{ PackageRooms: TPackageRoom[] }>({
    url:
      domain +
      `/api/sitecore/Fixture/GetFacilityPackages/?EventItemSitecoreID=${labels.eventItemSitecoreID}&EventId=${labels.eventId}&FacilityId=${facility.id}`,
    method: "GET",
  });

  return (
    <div className="o-fixture-packages">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {Boolean(data?.PackageRooms?.length)
            ? data?.PackageRooms?.map((packageRoom, index) => (
                <PackageRoom
                  key={index}
                  packageRoom={packageRoom}
                  renderPrice={renderPrice}
                  labels={labels}
                  facilityName={facility.title}
                  domain={domain}
                />
              ))
            : labels.noPackageOptionsText}
        </>
      )}
    </div>
  );
}

export default PackageRooms;
